module.exports = __webpack_public_path__ + "static/media/honor2.19f11b7f.jpg";